<template>
  <!-- <div class="service-details pt-120" id="service-details">
    <div class="container">
      <div class="row justify-content-center gy-5">
        <div class="col-lg-4 order-lg-1 order-2">
          <div class="service-sidebar">
            <div class="service-widget service-list-area">
              <h4 class="sidebar-title">软件产品</h4>
              <ul class="service-list">
                <li v-for="(item, index) in softwareList" :key="index">
                  <router-link @click="changeTab(index)" :to="item.path">{{
                    item.name
                  }}</router-link>
                  <svg
                    width="20"
                    height="16"
                    viewBox="0 0 20 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                    />
                  </svg>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-8 order-lg-2 order-1">
          <div class="service-details-area">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div id="Software" class="container">
    <div class="row">
      <div id="left" class="col-md-4 col-xs-12">
        <ServiceList
          :title="'产品与解决方案'"
          :items="softwareList"
          :activeIndex="active"
          @tab-change="changeTab"
        />
        <!-- <div class="service-widget service-list-area">
          <h4 class="sidebar-title">软件产品</h4>
          <ul class="service-list">
            <li
              v-for="(item, index) in softwareList"
              :key="index"
              :class="active == index ? 'active' : ''"
            >
              <router-link @click="changeTab(index)" :to="item.path">{{
                item.name
              }}</router-link>
              <svg
                width="20"
                height="16"
                viewBox="0 0 20 16"
                xmlns="http://www.w3.org/2000/svg"
                :style="active == index ? 'fill:#fff' : ''"
              >
                <path
                  d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                />
              </svg>
            </li>
          </ul>
        </div> -->
        <!-- <ul class="left-container wow bounceInLeft">
          <p>软件产品</p>
          <li
            v-for="(item, index) in softwareList"
            :class="active == index ? 'active' : ''"
            :key="index"
          >
            <router-link @click="changeTab(index)" :to="item.path">{{
              item.name
            }}</router-link>
          </li>
        </ul> -->
      </div>
      <!-- <div id="left" class="col-lg-4 order-lg-1 order-2">
        <div class="service-sidebar">
          <div class="service-widget service-list-area">
            <h4 class="sidebar-title">软件产品</h4>
            <ul class="service-list">
              <li v-for="(item, index) in softwareList" :key="index">
                <router-link @click="changeTab(index)" :to="item.path">{{
                  item.name
                }}</router-link>
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                  />
                </svg>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
      <div
        id="right"
        class="col-md-8 col-xs-12 wow bounceInRight"
        @touchstart="onTouchStart"
        @touchend="onTouchEnd"
      >
        <router-view></router-view>
        <div class="swipe-pager">
          <button
            type="button"
            class="pager-btn"
            :disabled="active <= 0"
            @click="goPrev"
          >
            <span class="pager-ico">&#8249;</span> 上一个
          </button>
          <span class="pager-count">{{ active + 1 }} / {{ softwareList.length }}</span>
          <button
            type="button"
            class="pager-btn"
            :disabled="active >= softwareList.length - 1"
            @click="goNext"
          >
            下一个 <span class="pager-ico">&#8250;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import ServiceList from "@/components/ServiceList.vue";
export default {
  name: "Software",
  components: {
    ServiceList,
  },
  data() {
    return {
      softwareList: [
         {
          path: "/software/software1",
          name: "医疗健康 - 智慧医院智能导诊系统",
        },
        {
          path: "/software/software2",
          name: "医疗健康 - 智慧医院便民服务系统",
        },
        {
          path: "/software/software3",
          name: "医疗健康 - 智慧医院医护管理系统",
        }, {
          path: "/software/software4",
          name: "医疗健康 - 智慧医院在线问诊系统",
        },
        {
          path: "/software/software5",
          name: "医疗健康 - 智慧医院健康管理系统",
        },
        {
          path: "/software/software6",
          name: "医疗健康 - 智慧医院居家护理系统",
        },
        {
          path: "/software/software11",
          name: "医疗健康 - 新质服务投诉管理系统",
        }, {
          path: "/software/software12",
          name: "医疗健康 - 新质服务满意度管理系统",
        }, {
          path: "/software/software13",
          name: "医疗健康 - 数字医工医疗设备管理系统",
        },{
          path: "/software/software15",
          name: "医疗健康 - 数字医工医疗设备运营系统",
        }
      ],
      active: 0,
      touchX: 0,
      touchY: 0,
    };
  },
  watch: {
    // 监听到路由地址的改变
    $route: {
      immediate: true,
      handler() {
        if (this.$route.path) {
          this.softwareList.forEach((element, index) => {
            if (element.path == this.$route.path) {
              this.active = index;
            }
          });
        }
      },
    },
  },
  methods: {
    changeTab(i) {
      this.active = i;
      this.$router.push(this.softwareList[i].path);
    },
    // ---- 移动端左右滑动切换产品 ----
    onTouchStart(e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      this.touchX = e.changedTouches[0].clientX;
      this.touchY = e.changedTouches[0].clientY;
    },
    onTouchEnd(e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - this.touchX;
      var dy = e.changedTouches[0].clientY - this.touchY;
      // 横向位移足够大且明显大于纵向，避免与纵向滚动冲突
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) {
          this.goNext();
        } else {
          this.goPrev();
        }
      }
    },
    goPrev() {
      if (this.active > 0) this.goTo(this.active - 1);
    },
    goNext() {
      if (this.active < this.softwareList.length - 1) this.goTo(this.active + 1);
    },
    goTo(i) {
      if (i < 0 || i >= this.softwareList.length) return;
      this.active = i;
      this.$router.push(this.softwareList[i].path);
      this.scrollToContent();
    },
    scrollToContent() {
      this.$nextTick(function () {
        var el = document.getElementById("right");
        if (el) {
          var y = el.getBoundingClientRect().top + window.scrollY - 70;
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: "smooth" });
        }
      });
    },
  },
  created() {},
  mounted() {
    var wow = new WOW();
    wow.init();
  },
};
</script>
<style scoped>
@import url("../assets/css/bootstrap.min.css");
@import url("../assets/css/style.css");
#left {
  margin: 50px 0;
}
.left-container {
  width: 80%;
  margin: 0 auto;
  border: 1px solid #474747;
  border-radius: 5px;
}
.left-container > p {
  text-align: center;
  line-height: 45px;
  padding: 0;
  margin: 0;
  background: #474747;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}
.left-container > li {
  text-align: left;
  padding-left: 10px;
  height: 38px;
  line-height: 38px;
  margin: 0;
  border-top: 1px solid #474747;
}
.left-container > li > a {
  text-decoration: none;
}
.left-container > li:hover {
  background: #928989;
}
#right {
  padding: 50px 0;
}
@media screen and (max-width: 768px) {
  #right {
    padding: 15px;
  }

  .left-container {
    width: 90%;
    margin: 0 auto;
    border: 1px solid #474747;
    border-radius: 5px;
  }
}
/* 移动端：隐藏左侧产品切换竖列表，改为内容区左右滑动切换 + 底部分页控件（桌面端不显示） */
.swipe-pager {
  display: none;
}
@media screen and (max-width: 768px) {
  #left {
    display: none;
  }
  .swipe-pager {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
  .swipe-pager .pager-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    font-size: 14px;
    line-height: 1;
    color: #18212e;
    background: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    transition: all 0.25s ease;
  }
  .swipe-pager .pager-btn:not(:disabled):active {
    color: #fff;
    background: #e6004c;
    border-color: #e6004c;
  }
  .swipe-pager .pager-btn:disabled {
    opacity: 0.4;
  }
  .swipe-pager .pager-count {
    font-size: 13px;
    font-weight: 600;
    color: #8a8f99;
  }
  .swipe-pager .pager-ico {
    font-size: 18px;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Software.vue